import React, { useEffect, useMemo, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Tabs, Tab, Box, Typography, Grid, Card, Paper } from '@mui/material';
import { UploadImageV2 } from '../../UploadImage/UploadImageV2';
import { TempAutoSelectInput } from '../../Input/TempAutoSelectInput'
import { TempTextInput } from '../../Input/TempTextInput'
import { TempBtn } from '../../Input/TempBtn'

import DeleteIcon from '@mui/icons-material/Delete'
import PhotoCamera from '@mui/icons-material/PhotoCamera'
import SwapVertIcon from '@mui/icons-material/SwapVert'
import PropTypes from 'prop-types'

import { constants as cons, IMAGE_TYPE } from '../../../Constants/constants';

import { PhotoProvider, PhotoView } from 'react-photo-view'

const viewOnlyKey = [
    "CASH_COUPON_DETAIL",
    "CASH_COUPON_PURCHASED_DETAIL",
]

// Readable display maps for your i18n keys
const LANGUAGE_LABELS = {
  'en': 'English (US)',
  'zh-HK': '繁體中文 (香港)',
  'zh-TW': '繁體中文 (台灣)',
  'zh-CN': '简体中文 (中国)'
};

const LANGUAGE_KEY_MAP = {
    EN: 'en',
    en: 'en',
    ZH_HK: 'zh-HK',
    'zh-HK': 'zh-HK',
    zh_HK: 'zh-HK',
    ZH_TW: 'zh-TW',
    'zh-TW': 'zh-TW',
    zh_TW: 'zh-TW',
    ZH_CN: 'zh-CN',
    'zh-CN': 'zh-CN',
    zh_CN: 'zh-CN',
};

const DEFAULT_LANGUAGE_ORDER = ['zh-HK', 'zh-TW', 'en', 'zh-CN'];

const normalizeLanguageKey = (languageKey) => LANGUAGE_KEY_MAP[languageKey] || languageKey;

const normalizeImageLanguageMap = (imageMap) => {
    if (!imageMap || typeof imageMap !== 'object' || Array.isArray(imageMap)) {
        return imageMap || {};
    }

    if (imageMap.cosFileUrl || imageMap.cosFileKey) {
        return {
            en: imageMap,
        };
    }

    return Object.entries(imageMap).reduce((accumulator, [languageKey, imageData]) => {
        accumulator[normalizeLanguageKey(languageKey)] = imageData;
        return accumulator;
    }, {});
};

export default function I18nImageTabs({ templateData, onSaveImage, tabKey, itemIndex = 0, ...props }) {
    const { 
        typeList, 
        type, 
        data, 
        uploadPath, 
        onDeleteImage, 
        onChangeImageType, 
        handleImageStatus, 
        index, 
        disableInput,
        validation,
        validationConstants,
        savedData,
        helperTextStylesClasses,
        resource,
        hiddenInput
    } = props;

    const normalizedTemplateData = useMemo(() => {
        return {
            ...(templateData || {}),
            // iconImage: normalizeImageLanguageMap(templateData?.iconImage),
            // detailImage: normalizeImageLanguageMap(templateData?.detailImage),
            // cashCouponDetailPurchasedImage: normalizeImageLanguageMap(
            //     templateData?.cashCouponDetailPurchasedImage || templateData?.detailPurchaseImage
            // ),
        };
    }, [templateData]);

    const languages = useMemo(() => {
        const availableLanguageSet = new Set([
            ...Object.keys(normalizedTemplateData || {}),
            // ...Object.keys(normalizedTemplateData.iconImage || {}),
            // ...Object.keys(normalizedTemplateData.detailImage || {}),
            // ...Object.keys(normalizedTemplateData.cashCouponDetailPurchasedImage || {}),
        ]);
        return DEFAULT_LANGUAGE_ORDER.filter((languageKey) => availableLanguageSet.has(languageKey));
    }, [normalizedTemplateData]);
    
    const [selectedLang, setSelectedLang] = useState(languages[0] || 'zh-HK');

    useEffect(() => {
        if (!languages.length) {
            setSelectedLang('zh-HK');
            return;
        }

        if (!languages.includes(selectedLang)) {
            setSelectedLang(languages[0]);
        }
    }, [languages, selectedLang]);

    const handleTabChange = (event, newLanguage) => {
        setSelectedLang(newLanguage);
    };

    const AntTabs = styled(Tabs)({
        borderBottom: '1px solid #e8e8e8',
        '& .MuiTabs-indicator': {
            backgroundColor: '#2b6611',
        },
    });

    const AntTab = styled(Tab)({
        color: '#2b6611)',
        '&.Mui-selected': {
        color: '#2b6611',
        },
        '&.Mui-focusVisible': {
        backgroundColor: 'rgba(100, 95, 228, 0.32)',
        },
    });
    
    return (
        <Box sx={{ width: '100%', bgcolor: 'background.paper', p: 3, borderRadius: 2 }}>
            {/* Tab Navigation */}
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <AntTabs 
                    value={selectedLang} 
                    onChange={handleTabChange} 
                    variant="scrollable"
                    scrollButtons="auto"
                >
                {languages.map((lang) => (
                    <AntTab 
                    key={lang} 
                    label={LANGUAGE_LABELS[lang] || lang} 
                    value={lang} 
                    />
                ))}
                </AntTabs>
            </Box>

            {/* Tab Panel Content: Loops over categories for the SELECTED language */}
            <Grid container spacing={3}>
                {console.log('normalizedTemplateData', normalizedTemplateData)}
                {
                    normalizedTemplateData && !viewOnlyKey.includes(normalizedTemplateData?.[selectedLang]?.type) ? (
                        <Card key={`${tabKey}-${index}`} className="image-list image-card-background">
                            <div className="image-list-content">
                                {/* {!showAll && <SwapVertIcon color={cons.STYLE.PRIMARY} fontSize={cons.SIZE.LARGE} />} */}
                                <div className="image-show">
                                <UploadImageV2
                                    type={type}
                                    picture={normalizedTemplateData?.[selectedLang]}
                                    title={{ resource: 'UploadImage', key: 'image' }}
                                    name="image"
                                    uploadImagePath={uploadPath}
                                    saveImage={(name, image) => onSaveImage(tabKey, selectedLang, name, image, itemIndex)}
                                    index={index}
                                    disableInput={disableInput}
                                />
                                </div>
                                {typeList && disableInput !== true ? (
                                <TempAutoSelectInput
                                    inputSetting={{
                                    className: 'edit-create-input',
                                    size: cons.SIZE.SMALL,
                                    variant: cons.STYLE.VARIANT.OUTLINED,
                                    type: cons.TYPE.SELECT,
                                    selectValue: typeList.filter((item) => item.value !== 'CATEGORY_ALL' && item.value !== 'ITEM_ALL'),
                                    label: { resource: 'productCreateProductList', key: 'type' },
                                    value: normalizedTemplateData?.[selectedLang]?.type,
                                    disabled: disableInput,
                                    disableClearable: true,
                                    helperTextIcon: true,
                                    helperText: validation
                                        ?.getErrorMessages(
                                        validationConstants.KEY_PRODUCT_IMAGE_TYPE,
                                        savedData?.draft?.product?.productCode,
                                        normalizedTemplateData?.[selectedLang]?.id ? normalizedTemplateData?.[selectedLang]?.id : normalizedTemplateData?.[selectedLang]?.cosFileKey
                                        )
                                        .map((error) => {
                                        return error
                                        }),
                                    FormHelperTextProps: { className: helperTextStylesClasses.root },
                                    }}
                                    handleChange={(_name, imageType) => onChangeImageType(tabKey, selectedLang, imageType, itemIndex)}
                                    index={index}
                                />
                                ) : (
                                <TempTextInput
                                    inputSetting={{
                                    className: 'edit-create-input',
                                    variant: cons.STYLE.VARIANT.STANDARD,
                                    size: cons.SIZE.SMALL,
                                    label: { resource: resource, key: 'type' },
                                    value: normalizedTemplateData?.[selectedLang]?.type,
                                    disabled: true,
                                    }}
                                    index={index}
                                />
                                )}
                                <TempTextInput
                                inputSetting={{
                                    className: 'edit-create-input',
                                    variant: cons.STYLE.VARIANT.STANDARD,
                                    type: cons.TYPE.NUMBER,
                                    min: -1,
                                    size: cons.SIZE.SMALL,
                                    label: { resource: resource, key: 'displaySequence' },
                                    value: normalizedTemplateData?.[selectedLang]?.displaySequence,
                                    disabled: true,
                                }}
                                index={index}
                                />
                                {!normalizedTemplateData?.[selectedLang]?.id ? (
                                !hiddenInput && (
                                    <div className="edit-create-input">
                                    <TempBtn
                                        btnSetting={{
                                        className: 'edit-create-btn',
                                        variant: cons.STYLE.VARIANT.CONTAINED,
                                        color: cons.STYLE.PRIMARY,
                                        onClick: () => onDeleteImage(tabKey, selectedLang, itemIndex),
                                        label: { key: 'deleteBtn' },
                                        icon: <DeleteIcon />,
                                        disabled: disableInput,
                                        }}
                                    />
                                    </div>
                                )
                                ) : !disableInput ? (
                                <TempAutoSelectInput
                                    inputSetting={{
                                    className: 'edit-create-input',
                                    size: cons.SIZE.SMALL,
                                    variant: cons.STYLE.VARIANT.OUTLINED,
                                    type: cons.TYPE.SELECT,
                                    selectValue: cons.CHOICES.PRODUCT_CREATE.CREATE_CATEGORY.STATUS,
                                    label: { resource: resource, key: 'status' },
                                    value: normalizedTemplateData?.[selectedLang]?.status ? normalizedTemplateData?.[selectedLang]?.status : '',
                                    disabled: disableInput,
                                    }}
                                    handleChange={(_name, status) => handleImageStatus(tabKey, selectedLang, status, itemIndex)}
                                    index={index}
                                />
                                ) : (
                                <TempTextInput
                                    inputSetting={{
                                    className: 'edit-create-input',
                                    variant: cons.STYLE.VARIANT.STANDARD,
                                    size: cons.SIZE.SMALL,
                                    label: { resource: resource, key: 'status' },
                                    value: normalizedTemplateData?.[selectedLang]?.status ? normalizedTemplateData?.[selectedLang]?.status : '',
                                    disabled: true,
                                    }}
                                    index={index}
                                />
                                )}
                            </div>
                        </Card>
                    ) : (
                        <PhotoProvider>
                            <Grid item xs={6}>
                                {/* <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1, textTransform: 'uppercase', fontWeight: 'bold' }}>
                                    ({selectedLang})
                                </Typography> */}

                                <PhotoView src={normalizedTemplateData?.[selectedLang]?.cosFileUrl}>
                                    {/* <img style={} src={fileData?.cosFileUrl} alt="" /> */}
                                    <Box
                                        component="img"
                                        src={normalizedTemplateData?.[selectedLang]?.cosFileUrl}
                                        title="Image"
                                        alt="img"
                                        sx={{ width: '100%', maxHeight: 260, objectFit: 'contain', borderRadius: 1 }}
                                    />
                                </PhotoView>
                            </Grid>
                        </PhotoProvider>
                    )
                }
            </Grid>
        </Box>
    );
}

